/**
 * Implements methods for reading and writing preferences to local storage, e.g. asset display mode
 */
export default class Prefs {
  setAssetDisplayMode (assetType, displayMode) {
    let preferences = this.getOrCreatePreferences()
    if (!preferences.asset) {
      preferences.asset = {}
    }
    if (!preferences.asset.displayMode) {
      preferences.asset.displayMode = {}
    }
    preferences.asset.displayMode[assetType.id] = displayMode
    this.save(preferences)
  }

  getAssetDisplayMode (assetType) {
    let preferences = this.getOrCreatePreferences()
    if (preferences.asset && preferences.asset.displayMode && preferences.asset.displayMode[assetType.id]) {
      return preferences.asset.displayMode[assetType.id]
    }
    return 'TABLE'
  }

  getOrCreatePreferences () {
    let sPreferences = localStorage.getItem('Preferences')
    let preferences
    if (sPreferences && sPreferences !== '') {
      try {
        preferences = JSON.parse(sPreferences)
      } catch (e) {
        preferences = {}
      }
    } else {
      preferences = {}
    }
    return preferences
  }

  save (preferences) {
    localStorage.setItem('Preferences', JSON.stringify(preferences))
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/prefs.js